var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"base-progress-bar"},_vm.$listeners),[_c('div',{staticClass:"base-progress-bar__background"},[_c('div',{staticClass:"base-progress-bar__indicator",class:_setup.baseProgressBarIndicatorClasses,style:(_setup.baseProgressBarIndicatorStyles)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }